import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { marked } from 'marked';
import { Message } from '../../../../model/chat.model';
@Component({
  standalone: true,
  selector: 'app-message-bubble',
  imports: [CommonModule],
  templateUrl: './message-bubble.component.html',
  styleUrls: ['./message-bubble.component.css']
})
export class MessageBubbleComponent implements OnChanges {
  @Input() message!: Message;
  renderedHtml = '';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['message']) {
      this.renderedHtml = this.message.role === 'assistant'
        ? marked.parse(this.message.content ?? '') as string
        : this.escapeHtml(this.message.content);
    }
  }

  private escapeHtml(text: string): string {
    return text
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }
}
